module.exports = __webpack_public_path__ + "1_0_64/img/volume.b5207e5d.svg";